import React from 'react'
import Location from '@assets/img/reservation/location.svg'
import Info from '@assets/img/reservation/info.svg'
import StarFull from '@assets/img/reservation/star_full.svg'
import Plane from '@assets/img/reservation/plane.svg'
import Car from '@assets/img/reservation/car.svg'
import Clock from '@assets/img/reservation/clock.svg'
import Food from '@assets/img/reservation/food.svg'
import People from '@assets/img/reservation/people.svg'
import House from '@assets/img/reservation/house.svg'
import ChevronRightPink from '@assets/img/reservation/chevron-right-pink.svg'
import Loader from '../search-trip/components/Loader'
import { useReservationContext } from './ReservationContext'
import ReactTooltip from 'react-tooltip'
import uuidv4 from 'uuid/v4'
import CashbackDisplay from '../search-trip-offer/components/OfferConfigForm/fields/CashbackDisplay'

const Sidebar = ({ showTransportExtras = true }) => {
    const {
        loading,
        offer,
        dataUdds,
        adults,
        children,
        selectedInsurance,
        selectedParkingOffer,
        cashbackDisplayEnabled,
        promotionPreview,
        getReservationTotalPrice,
        earnedCashbackAmount,
        t
    } = useReservationContext()
    const tooltipId = uuidv4()

    const formatBool = (value) => {
        if (value === true) {
            return t('yes')
        }

        if (value === false) {
            return t('no')
        }

        return '-'
    }

    return (
        <div className="trip-reservation__sidebar">
            <div>
                <div className="trip-reservation__sidebar-heading">{t('summary')}</div>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <div className="trip-reservation__summary">
                            <div className="trip-reservation__summary-details">
                                <div>
                                {t('trip')}
                                    <span>
                                        {offer.price ? Number((offer.price / 100).toFixed(2)) : '-'}{' '}
                                        {offer.currency ? offer.currency : 'PLN'}
                                    </span>
                                </div>
                                {selectedInsurance && selectedInsurance.variant && (
                                    <div>
                                        {t('insurance')}
                                        <span>{selectedInsurance.totalPrice ? selectedInsurance.totalPrice : '-'} PLN</span>
                                    </div>
                                )}
                                { selectedParkingOffer && selectedParkingOffer.parking && (
                                    <div>
                                        Parking
                                        <span>{selectedParkingOffer.price_online ? selectedParkingOffer.price_online : '-'} PLN</span>
                                    </div>
                                )}
                                {promotionPreview && Number(promotionPreview.discountAmountTotal || 0) > 0 && (
                                    <div>
                                        {t('discount')}
                                        <span>-{Number(promotionPreview.discountAmountTotal).toFixed(2)} PLN</span>
                                    </div>
                                )}
                                {promotionPreview && Number(promotionPreview.giftVoucherAmountTotal || 0) > 0 && (
                                    <div>
                                        {t('gift-voucher-label')}
                                        <span>-{Number(promotionPreview.giftVoucherAmountTotal).toFixed(2)} PLN</span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr className="trip-reservation__divider" />
                        <div className="trip-reservation__location">
                            <img src={Location} alt="" />
                            <div className="trip-reservation__location-details">
                                <div className="trip-reservation__location-name">
                                    {offer.offerName ? offer.offerName : '-'}
                                </div>
                                <div className="trip-reservation__location-stars">
                                    {offer.category
                                        ? Array(Math.floor(offer.category / 10))
                                              .fill()
                                              .map((_, i) => <img key={`star-${i}`} src={StarFull} alt="" />)
                                        : '-'}
                                </div>
                                <div className="trip-reservation__location-desc">
                                    {offer.country ? offer.country : '-'} / {offer.region ? offer.region : '-'} /{' '}
                                    {offer.city ? offer.city : '-'}
                                </div>
                            </div>
                        </div>
                        <div className="trip-reservation__sidebar-boxes">
                            {offer.transport && offer.transport.H && offer.transport.H === 'wlasny' ? (
                                <div className="summary__trip-details summary__trip-details--flight">
                                    <div className="summary__trip-details-row">
                                        <div className="summary__trip-details-title">
                                            <img src={Plane} alt="plane" />
                                            {t('transport')}
                                        </div>
                                    </div>
                                    <div className="summary__trip-details-desc">{t('transport-own')}</div>
                                </div>
                            ) : (
                                <>
                                    <div className="trip-reservation__trip-details trip-reservation__trip-details--flight">
                                        <div className="trip-reservation__trip-details-row">
                                            <div className="trip-reservation__trip-details-title">
                                                {offer.country && offer.country === 'Polska' ? (
                                                    <>
                                                        <img src={House} alt="house" />
                                                        {t('trip-start')}
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={Plane} alt="plane" />
                                                        {t('departure')}
                                                    </>
                                                )}
                                            </div>
                                            <div className="trip-reservation__trip-details-date">
                                                {offer.departureDate ? offer.departureDate : '-'}
                                            </div>
                                        </div>
                                        {offer.country && offer.country !== 'Polska' && (
                                            <div className="trip-reservation__trip-details-desc">
                                                {offer.departureFrom ? offer.departureFrom : '-'}{' '}
                                                <img src={ChevronRightPink} alt="chevron-right" />{' '}
                                                {offer.departureTo ? offer.departureTo : '-'}
                                            </div>
                                        )}
                                    </div>
                                    { !(offer.charterType && offer.tripDirection === 'oneWay') && (
                                        <div className="trip-reservation__trip-details trip-reservation__trip-details--flight">
                                            <div className="trip-reservation__trip-details-row">
                                                <div className="trip-reservation__trip-details-title">
                                                    {offer.country && offer.country === 'Polska' ? (
                                                        <>
                                                            <img src={House} alt="house" />
                                                            {t('trip-end')}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={Plane} alt="plane" />
                                                            {t('arrival')}
                                                        </>
                                                    )}
                                                </div>
                                                <div className="trip-reservation__trip-details-date">
                                                    {offer.returnDate ? offer.returnDate : '-'}
                                                </div>
                                            </div>

                                            {offer.country && offer.country !== 'Polska' && (
                                                <div className="trip-reservation__trip-details-desc">
                                                    {offer.departureTo ? offer.departureTo : '-'}{' '}
                                                    <img src={ChevronRightPink} alt="chevron-right" />{' '}
                                                    {offer.departureFrom ? offer.departureFrom : '-'}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                            <div className="trip-reservation__trip-details trip-reservation__trip-details--gray">
                                {offer.length > 0 && (
                                    <div className="trip-reservation__trip-details-row">
                                        <div className="trip-reservation__trip-details-title">
                                            <img src={Clock} alt="Clock" />
                                            {t('duration-of-stay')}
                                        </div>
                                        <div className="trip-reservation__trip-details-date trip-reservation__trip-details-date--gray">
                                            {offer.length ? offer.length : '-'} dni
                                        </div>
                                    </div>
                                )}
                                {!offer.charterType && (
                                    <>
                                        <div className="trip-reservation__trip-details-name-box">
                                            <div className="trip-reservation__trip-details-row">
                                                <div className="trip-reservation__trip-details-title">
                                                    <img src={House} alt="house" />
                                                    {t('accommodation')}
                                                </div>
                                            </div>
                                            <div className="trip-reservation__trip-details-desc">
                                                {offer.roomType ? offer.roomType : '-'}
                                            </div>
                                        </div>
                                        <div className="trip-reservation__trip-details-name-box">
                                            <div className="trip-reservation__trip-details-row">
                                                <div className="trip-reservation__trip-details-title">
                                                    <img src={Food} alt="food" />
                                                    {t('feeding')}
                                                </div>
                                            </div>
                                            <div className="trip-reservation__trip-details-desc">
                                                {offer.feeding ? offer.feeding : ''}
                                            </div>

                                            {showTransportExtras &&
                                                typeof offer.transport === 'string' &&
                                                offer.transport.toLowerCase() === 'f' &&
                                                dataUdds && (
                                                <>
                                                    <div className="trip-reservation__trip-details-row">
                                                        <div className="trip-reservation__trip-details-title" style={{ marginLeft: 24 }}>
                                                            {t('luggage')}
                                                        </div>
                                                    </div>
                                                    <div className="trip-reservation__trip-details-desc">
                                                        {formatBool(dataUdds.luggage)}
                                                    </div>
                                                    <div className="trip-reservation__trip-details-row">
                                                        <div className="trip-reservation__trip-details-title" style={{ marginLeft: 24 }}>
                                                            {t('transferIncluded')}
                                                        </div>
                                                    </div>
                                                    <div className="trip-reservation__trip-details-desc">
                                                        {formatBool(dataUdds.transferIncluded)}
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}
                                <div className="trip-reservation__trip-details-name-box">
                                    <div className="trip-reservation__trip-details-row">
                                        <div className="trip-reservation__trip-details-title">
                                            <img src={People} alt="people" />
                                            {t('participants')}
                                        </div>
                                    </div>
                                    <div className="trip-reservation__trip-details-desc">
                                        {adults} dorosłych {children ? '+ ' + children + ' dzieci' : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr className="trip-reservation__divider" />
                        <div className="trip-reservation__trip-details trip-reservation__trip-details--dark">
                            <div className="trip-reservation__trip-details-row">{t('total-price')}</div>
                            <div className="trip-reservation__trip-details-price">
                                {offer.price ? Number((offer.price / 100).toFixed(2)) : '-'}{' '}PLN
                            </div>
                            <div className="trip-reservation__trip-details-final-price">
                                {t('final-price')}: {getReservationTotalPrice(true)} PLN
                            </div>
                            <div className="trip-reservation__summary-info">
                                <img src={Info} alt="info" data-for={tooltipId} data-tip="<b>TFG – Turystyczny Fundusz Gwarancyjny</b> – to obowiązkowa opłata, którą organizatorzy
                                        wycieczek doliczają do ceny, ustanowiona ustawą z 2017r.<br />
                                        <b>TFP – Turystyczny Fundusz Pomocowy</b> – fundusz zabezpieczający klientów i branżę turystyczną w sytuacjach
                                        nadzwyczajnych (np. pandemia)." />
                                {t('price-includes-fees')}
                                <ReactTooltip
                                    id={tooltipId}
                                    effect="solid"
                                    html={true}
                                    className="trip-reservation__tooltip"
                                    place="right"
                                />
                            </div>
                        </div>
                        {cashbackDisplayEnabled && Number(earnedCashbackAmount) > 0 && (
                            <CashbackDisplay
                                price={Number(earnedCashbackAmount)}
                                title={t('cashback-widget')}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default Sidebar
